/**
 * Hardcoded staff location data for the Team Globe visualization.
 * Each entry has a location name, lat/lng coordinates, IANA timezone, and staff count.
 */
const TEAM_LOCATIONS = [
    {
        name: "Wellington, NZ",
        lat: -41.29,
        lng: 174.78,
        timezone: "Pacific/Auckland",
        staff: 1,
        color: 0x00e5ff,
    },
    {
        name: "SF Bay Area, CA",
        lat: 37.77,
        lng: -122.42,
        timezone: "America/Los_Angeles",
        staff: 2,
        color: 0xff6e40,
    },
    {
        name: "Los Angeles, CA",
        lat: 34.05,
        lng: -118.24,
        timezone: "America/Los_Angeles",
        staff: 14,
        color: 0xff6e40,
    },
    {
        name: "Rhode Island",
        lat: 41.58,
        lng: -71.48,
        timezone: "America/New_York",
        staff: 1,
        color: 0x76ff03,
    },
    {
        name: "North Carolina",
        lat: 35.78,
        lng: -78.64,
        timezone: "America/New_York",
        staff: 1,
        color: 0x76ff03,
    },
    {
        name: "BC, Canada",
        lat: 49.28,
        lng: -123.12,
        timezone: "America/Vancouver",
        staff: 1,
        color: 0xffea00,
    },
    {
        name: "Toronto, Canada",
        lat: 43.65,
        lng: -79.38,
        timezone: "America/Toronto",
        staff: 1,
        color: 0xffea00,
    },
    {
        name: "Amsterdam, Netherlands",
        lat: 52.37,
        lng: 4.90,
        timezone: "Europe/Amsterdam",
        staff: 1,
        color: 0xe040fb,
    },
    {
        name: "Helsinki, Finland",
        lat: 60.17,
        lng: 24.94,
        timezone: "Europe/Helsinki",
        staff: 2,
        color: 0xe040fb,
    },
    {
        name: "Tokyo, Japan",
        lat: 35.68,
        lng: 139.69,
        timezone: "Asia/Tokyo",
        staff: 2,
        color: 0x00e5ff,
    },
];

export default TEAM_LOCATIONS;
